import styled, { css } from 'styled-components'
import { DefaultTheme } from 'styled-components'
import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { CardFeatures } from '../../molecules/CardFeatures/CardFeatures.styles'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'
import { Container } from '../../atoms/GridSystem'

interface FeatureBannerWithListProps {
  theme: DefaultTheme
  colorScheme: ColorSchemeTypes
}

interface FeatureBannerWithListBackgroundProps {
  theme: DefaultTheme
}

interface FeatureBannerWithListContentProps {
  theme: DefaultTheme
}

export const FeatureBannerWithList = styled.section<FeatureBannerWithListProps>`
  position: relative;
  width: 100%;
  height: ${({ theme }) => theme.rem(770)};
  overflow: hidden;
  display: flex;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg,rgba(255, 255, 255, 0) 65%, ${({ theme }) => theme.palette.green['400']} 100%);
    z-index: 1;
  }

  ${Container} {
    position: relative;
    z-index: 2;
    width: 100%;
  }
`

export const FeatureBannerWithListBackground = styled.div<FeatureBannerWithListBackgroundProps>`
  position: absolute;
  top: -25%;
  left: 0;
  width: 100%;
  height: 150%;
  z-index: 0;
  will-change: transform;

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const FeatureBannerWithListContent = styled.div<FeatureBannerWithListContentProps>`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: ${({ theme }) => theme.rem(16)};
  
  ${CardFeatures} {

    ${Paragraph},
    ${Heading} {
      color: ${({ theme }) => theme.palette.grayscale['50']};
    }
  }
`

export const FeatureBannerWithListSwiperWrapper = styled.div`
  position: relative;
  width: 100%;

  .swiper-wrapper {
    transition: all ease 0.3s;

    .swiper-slide {
      padding-top: ${({ theme }) => theme.rem(8)};
      height: auto !important;
    }
  }
`

export const FeatureBannerWithListNavigation = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 100%;
  padding-top: ${({ theme }) => theme.rem(32)};
  gap: ${({ theme }) => theme.rem(16)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FeatureBannerWithListNavigationButton = styled.div`
  position: relative;
  left: auto;
  transform: translateY(0);
  z-index: 1;

  button {
    width: ${({ theme }) => theme.rem(46)};
    height: ${({ theme }) => theme.rem(46)};
    padding: 0 !important;

    &:first-of-type {
      margin-left: 0;
    }

    &.swiper-button-lock {
      display: none;
    }
  }
`

export const FeatureBannerWithListButtonPrev = styled(FeatureBannerWithListNavigationButton)`
  left: 0;
`

export const FeatureBannerWithListButtonNext = styled(FeatureBannerWithListNavigationButton)`
  right: 0;
`

interface FeatureBannerWithListNavScrollbarProps {
  theme: DefaultTheme
  colorScheme: ColorSchemeTypes
}

export const FeatureBannerWithListNavScrollbar = styled.div<FeatureBannerWithListNavScrollbarProps>`
  width: 100%;
  height: 4px;
  margin-top: ${({ theme }) => theme.rem(24)};
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.inside};

  .swiper-scrollbar-drag {
    background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.outside};
  }
`

